<template>
    <div class="c-policy">
        <h2>
            Cookie Policy
        </h2>

        <p>
            The ABC Quantum software uses small files called cookies to help provide your experience.
        </p>

        <p>
            The cookies we currently use are:
        </p>

        <ul>
            <li>
                <a href="https://passport.bc-legal.co.uk/" target="_blank">
                    ABC Passport
                </a>
                &mdash; <span>required to provide secure authentication and keep you logged in whilst using the software.</span>
            <li>
                <a href="https://www.google.com/analytics/" target="_blank">
                    Google Analytics
                </a> 
                &mdash; <span>for providing details about how visitors and users of the software are navigating and using the tools.</span> 
            </li>
            <li>
                <a href="https://www.livechatinc.com/" target="_blank">
                    LiveChat
                </a> 
                &mdash; <span>for tracking what area of the software you are using when you submit feedback or request assistance from us.</span>
            </li>
        </ul>

        <p>
            Cookies are regulated by the <a href="https://ico.org.uk/for-the-public/online/cookies/" target="_blank">Information Commissioner's Office (ICO)</a>. They have four categories of cookie which we have listed below. We've also categorised our three cookies so you know what they are:
        </p>

        <table cellpadding="0" cellspacing="0" style="width: 100%;">
            <tbody>
                <tr>
                    <th width="20%">
                        <strong>
                            Cookie category
                        </strong>
                    </th>
                    <th width="20%">
                        <strong>
                            Cookies in use
                        </strong>
                    </th>
                    <th width="60%">
                        <strong>
                            Notice for users
                        </strong>
                    </th>
                </tr>
                <tr>
                    <td>
                        Category 1
                        <br>
                        (Strictly necessary cookies)
                    </td>
                    <td>
                        None
                    </td>
                    <td>
                        These cookies are essential in order to enable you to 
                        move around the website and use its features, such as 
                        accessing secure areas of the website. Without these 
                        cookies services you have asked for, like shopping 
                        baskets or e-billing, cannot be provided
                    </td>
                </tr>
                <tr>
                    <td>
                        Category 2
                        <br>
                        (Performance Cookies)
                    </td>
                    <td>
                        Google Analytics
                    </td>
                    <td>
                        These cookies collect information about how visitors use 
                        a website, for instance which pages visitors go to most 
                        often, and if they get error messages from web pages. <br>
                        These cookies don’t collect information that identifies a 
                        visitor. All information these cookies collect is aggregated 
                        and therefore anonymous. It is only used to improve how 
                        a website works.
                    </td>
                </tr>
                <tr>
                    <td>
                        Category 3
                        <br>
                        (Functionality cookies)
                    </td>
                    <td>
                        ABC Passport
                        <br>
                        LiveChat
                    </td>
                    <td>
                        These cookies allow the website to remember choices 
                        you make (such as your user name, language or the 
                        region you are in) and provide enhanced, more personal 
                        features. For instance, a website may be able to provide 
                        you with local weather reports or traffic news by storing 
                        in a cookie the region in which you are currently located. 
                        These cookies can also be used to remember changes 
                        you have made to text size, fonts and other parts of web 
                        pages that you can customise. They may also be used to 
                        provide services you have asked for such as watching a 
                        video or commenting on a blog. The information these 
                        cookies collect may be anonymised and they cannot track 
                        your browsing activity on other websites.
                    </td>
                </tr>
                <tr>
                    <td>
                        Category 4
                        <br>
                        (Targeting or Advertising cookies)
                    </td>
                    <td>
                        None
                    </td>
                    <td>
                        These cookies are used to deliver adverts more relevant 
                        to you and your interests They are also used to limit 
                        the number of times you see an advertisement as well 
                        as help measure the effectiveness of the advertising 
                        campaigns. They are usually placed by advertising 
                        networks with the website operator’s permission. They 
                        remember that you have visited a website and this 
                        information is shared with other organisations such as 
                        advertisers. Quite often targeting or advertising cookies 
                        will be linked to site functionality provided by the other 
                        organisation.
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'cookie-policy',
    }
</script>


// WEBPACK FOOTER //
// CookiePolicy.vue?b546c73c